import { Target, Users, Rocket } from 'lucide-react';

const About = () => {
  return (
    <section 
      id="about" 
      className="relative py-24 md:py-32 overflow-hidden"
      data-testid="about-section"
    >
      {/* Background */}
      <div className="absolute inset-0 bg-slate-950">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-slate-800 to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div data-testid="about-content">
            <span className="inline-block px-4 py-1.5 rounded-full border border-slate-800 bg-slate-900/50 text-sm text-blue-400 mb-6">
              About Us
            </span>
            <h2 
              className="font-space text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white mb-6"
              data-testid="about-title"
            >
              Crafting Digital Excellence Since 2018
            </h2>
            <div className="space-y-4 text-slate-400 leading-relaxed">
              <p>
                <strong className="text-white">Broadway Tech Solutions</strong> is a software development and consulting firm 
                dedicated to helping businesses transform their digital presence. We specialize in creating 
                custom web applications, mobile apps, and scalable backend systems.
              </p>
              <p>
                Our team of experienced engineers and designers work closely with clients to understand their 
                unique challenges and deliver solutions that drive real business value. We believe in building 
                long-term partnerships based on trust, transparency, and technical excellence.
              </p>
              <p>
                From startups launching their first product to enterprises modernizing legacy systems, 
                we bring the same level of dedication and expertise to every project.
              </p>
            </div>
          </div>

          {/* Right - Features */}
          <div className="space-y-6" data-testid="about-features">
            {[
              {
                icon: Target,
                title: 'Mission-Driven',
                description: 'We focus on delivering solutions that align with your business objectives and create measurable impact.',
              },
              {
                icon: Users,
                title: 'Client-Centric',
                description: 'Your success is our success. We work as an extension of your team, committed to your growth.',
              },
              {
                icon: Rocket,
                title: 'Innovation-Focused',
                description: 'We stay ahead of technology trends to bring you cutting-edge solutions that give you a competitive edge.',
              },
            ].map((feature, index) => (
              <div
                key={index}
                className="group flex gap-5 p-6 rounded-2xl bg-slate-900/30 border border-slate-800 hover:border-blue-500/30 transition-all duration-300"
                data-testid={`about-feature-${index}`}
              >
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500/20 to-indigo-500/20 border border-blue-500/20 flex items-center justify-center group-hover:border-blue-500/40 transition-colors">
                    <feature.icon className="w-6 h-6 text-blue-400" />
                  </div>
                </div>
                <div>
                  <h3 className="font-space text-lg font-semibold text-white mb-2 group-hover:text-blue-400 transition-colors">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-slate-500 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
